import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "./axiosInterceptor"; // Import the Axios instance

function OrderDetail() {

  const { id } = useParams();
  const [order, setOrder] = useState([]);


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await api.get("/orders/"+id);
        console.log(response.data)
        setOrder(response.data);
      } catch (error) {
        console.error("Error no products:", error);
      }
    };

    fetchProducts();
  }, []);

  return (
            <div>
                      <div className="container mt-4">
                        <div className="card invoice">
                            <div className="card-header p-4 p-md-5 border-bottom-0 bg-gradient-primary-to-secondary text-white-50">
                                <div className="row justify-content-between align-items-center">
                                    <div className="col-12 col-lg-auto mb-5 mb-lg-0 text-center text-lg-left">
                                        
                                        {/* <img className="invoice-brand-img rounded-circle mb-4" src="assets/img/demo/demo-logo.svg" alt="" /> */}
                                        <div className="h2 text-white mb-0">Pedido AGBAR</div>
                                        ES202500024
                                    </div>
                                    <div className="col-12 col-lg-auto text-center text-lg-right">
                                        
                                        <div className="h3 text-white">Estado: Enviado</div>
                                        ES202500024
                                        <br />
                                        Fecha entrega: 25/02/2024
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4 p-md-5">
                                
                                <div className="table-responsive">
                                    <table className="table table-borderless mb-0">
                                        <thead className="border-bottom">
                                            <tr className="small text-uppercase text-muted">
                                                <th scope="col">Descripción</th>
                                                <th className="text-right" scope="col">Cantidad</th>
                                                <th className="text-right" scope="col">Precio</th>
                                                <th className="text-right" scope="col">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            
                                            <tr className="border-bottom">
                                                <td>
                                                

                                                    <div className="font-weight-bold">Gini and Jony Girls Knit White Top</div>
                                                    <div className="small text-muted d-none d-md-block">Gini and Jony Girls Knit White Top <strogn>SN: 23eaf972-754f-42ad</strogn></div>
                                                </td>
                                                <td className="text-right font-weight-bold">12</td>
                                                <td className="text-right font-weight-bold">50.00€</td>
                                                <td className="text-right font-weight-bold">600.00€</td>
                                            </tr>
                                            
                                            <tr className="border-bottom">
                                                <td>
                                                <div className="font-weight-bold">Gini and Jony Girls Knit White Top</div>
                                                    <div className="small text-muted d-none d-md-block">Gini and Jony Girls Knit White Top <strogn>SN: 23eaf972-754f-42ad</strogn></div>
                                                </td>
                                                <td className="text-right font-weight-bold">15</td>
                                                <td className="text-right font-weight-bold">55.00€</td>
                                                <td className="text-right font-weight-bold">825.00€</td>
                                            </tr>
                                            
                                            <tr className="border-bottom">
                                                <td>
                                                <div className="font-weight-bold">Gini and Jony Girls Knit White Top</div>
                                                    <div className="small text-muted d-none d-md-block">Gini and Jony Girls Knit White Top <strogn>SN: 23eaf972-754f-42ad</strogn></div>
                                                </td>
                                                <td className="text-right font-weight-bold">4</td>
                                                <td className="text-right font-weight-bold">125.00€</td>
                                                <td className="text-right font-weight-bold">500.00€</td>
                                            </tr>
                                            
                                            <tr>
                                                <td className="text-right pb-0" colSpan="3"><div className="text-uppercase small font-weight-700 text-muted">Subtotal:</div></td>
                                                <td className="text-right pb-0"><div className="h5 mb-0 font-weight-700">1925.00€</div></td>
                                            </tr>
                                            
                                            <tr>
                                                <td className="text-right pb-0" colSpan="3"><div className="text-uppercase small font-weight-700 text-muted">IVA (21%):</div></td>
                                                <td className="text-right pb-0"><div className="h5 mb-0 font-weight-700">134.75€</div></td>
                                            </tr>
                                            
                                            <tr>
                                                <td className="text-right pb-0" colSpan="3"><div className="text-uppercase small font-weight-700 text-muted">Total:</div></td>
                                                <td className="text-right pb-0"><div className="h5 mb-0 font-weight-700 text-green">2059.75€</div></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="card-footer p-4 p-lg-5 border-top-0">
                                <div className="row">
                                <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
                                        
                                        <div className="small text-muted text-uppercase font-weight-700 mb-2">Enviado por:</div>
                                        <div className="h6 mb-0">Econocom Products & Solutions SAU</div>
                                        <div className="small">Marcelo Spínola 5</div>
                                        <div className="small">Madrid, 28801</div>
                                    </div>

                                    <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
                                        
                                        <div className="small text-muted text-uppercase font-weight-700 mb-2">Enviado a:</div>
                                        <div className="h6 mb-1">AGBAR</div>
                                        <div className="small">Dirección 123</div>
                                        <div className="small">Ciuad 288000, Soria</div>
                                    </div>

                                    <div className="col-lg-6">
                                        
                                        <div className="small text-muted text-uppercase font-weight-700 mb-2">Notas</div>
                                        <div className="small mb-0">Prow scuttle parrel provost Sail ho shrouds spirits boom mizzenmast yardarm. Pinnace holystone mizzenmast quarter crow's nest nipperkin grog yardarm hempen halter furl. Swab barque interloper chantey doubloon starboard grog black jack gangway rutters.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
     
    </div>
  );
}

export default OrderDetail;
